import {BitrixVue} from 'ui.vue3';
import './libs/scripts.min';
import './application.css';

import {SearchRoutesContainer} from './component/search_container';

export class SearchRoutes
{
    #application = null;
    rootNode = null;

    constructor(rootNode): void
    {
        this.rootNode = document.querySelector(rootNode);
    }

    start(): void
    {
        this.attachTemplate({})
    }

    attachTemplate(options): void
    {
        const context = this;

        this.#application = BitrixVue.createApp({
            name: 'SearchRoutes',
            created()
            {
            },
            mounted()
            {
                this.$Bitrix.eventEmitter.subscribe('akatan:search_routes:loading_on', this.loading_on)
                this.$Bitrix.eventEmitter.subscribe('akatan:search_routes:loading_off', this.loading_off)
            },
            beforeMount() {
                this.activateActivityTracker();
            },
            beforeUnmount()
            {
                this.$Bitrix.eventEmitter.unsubscribe('akatan:search_routes:loading_on', this.loading_on)
                this.$Bitrix.eventEmitter.unsubscribe('akatan:search_routes:loading_off', this.loading_off)
            },
            beforeDestroy() {
                window.removeEventListener("mousemove", this.userActivityThrottler);
                window.removeEventListener("scroll", this.userActivityThrottler);
                window.removeEventListener("keydown", this.userActivityThrottler);
                window.removeEventListener("resize", this.userActivityThrottler);
                window.removeEventListener("mousedown", this.userActivityThrottler);
                window.removeEventListener("mouseup", this.userActivityThrottler);

                clearTimeout(this.userActivityTimeout);
                clearTimeout(this.userActivityThrottlerTimeout);
            },
            data(): object
            {
                return {
                    USER_ACTIVITY_THROTTLER_TIME: 3000,
                    isInactive: false,
                    userActivityTimeout: false,
                    userActivityThrottlerTimeout: false,

                    isLoading: false,
                }
            },
            components: {
                SearchRoutesContainer
            },
            beforeCreate(): void
            {
                this.$bitrix.Application.set(context);
            },
            methods: {
                loading_on(event) {

                    this.isLoading = true;
                },
                loading_off(event) {

                    this.isLoading = false;
                },
                resetUserActivityTimeout()
                {
                    clearTimeout(this.userActivityTimeout);
                    this.userActivityTimeout = setTimeout(() => {
                        this.inactiveUserAction();
                    }, this.USER_ACTIVITY_THROTTLER_TIME);
                },

                inactiveUserAction()
                {
                    this.isInactive = false;
                },

                activateActivityTracker() {
                    window.addEventListener("mousemove", this.userActivityThrottler);
                    window.addEventListener("scroll", this.userActivityThrottler);
                    window.addEventListener("keydown", this.userActivityThrottler);
                    window.addEventListener("resize", this.userActivityThrottler);
                    window.addEventListener("mousedown", this.userActivityThrottler);
                    window.addEventListener("mouseup", this.userActivityThrottler);
                },

                userActivityThrottler() {

                    this.isInactive = true;
                    this.setLastActiveUser();
                    if (!this.userActivityThrottlerTimeout) {
                        this.userActivityThrottlerTimeout = setTimeout(() => {
                            this.resetUserActivityTimeout();

                            clearTimeout(this.userActivityThrottlerTimeout);
                            this.userActivityThrottlerTimeout = null;
                        }, this.USER_ACTIVITY_THROTTLER_TIME);
                    }
                },

                setLastActiveUser()
                {

                    let vm = this;
                    let countdown_user = JSON.parse(window.localStorage.getItem('countdownActiveUser') || `{"id": 0, "time": ` + new Date().getTime() + `}`);
                    let count_time = countdown_user.time;

                    if ((new Date().getTime()) - count_time >= 0) {

                        if (countdown_user.id > 0) {
                            clearTimeout(countdown_user.id);
                        }
                        countdown_user = {
                            time: new Date().getTime(),
                        }

                        const timerUserActiveID = setTimeout(() => {
                        },countdown_user.time -  new Date().getTime());
                        countdown_user.id = timerUserActiveID;
                        window.localStorage.setItem('countdownActiveUser', JSON.stringify(countdown_user));
                    }
                },

            },
            template: `<div v-if="isLoading" class="loading-content">
                <div class="loading-content__container">
                    <img src="/local/js/akatan/order_ticket/src/img/loading.gif" alt="Загрузка">
                </div>
            </div>
            <SearchRoutesContainer />`
        });
        this.#application.component("settlement-input", {
            props: ["modelValue", "depotId"],
            template: `<input type="text" name="settlement" placeholder="КУДА?" class="" data-id="" :value="modelValue" autocomplete="off" required="">`,
            mounted() {
                let vm = this;

                $(vm.$el)
                    .autocomplete({
                        serviceUrl: '/local/ajax/ru/destination_autofill.php',
                        params: {
                            'depotId': vm.depotId,
                        },
                        deferRequestBy: 500,
                        minLength: 2,
                        minChars: 2,
                        onSelect: function (autofill) {
                            vm.setAutofill({
                                autofill
                            });

                        }
                    });
            },
            watch: {
                modelValue(value) {

                    $(this.$el)
                        .val(value)
                        .trigger("change");
                },
                depotId(value)
                {
                    let vm = this;

                    $(vm.$el).on('keyup', function () {
                        let layout = vm.auto_layout_keyboard(this.value);

                        $(vm.$el).val(layout)

                    });

                    $(vm.$el)
                        .autocomplete({
                            serviceUrl: '/local/ajax/ru/destination_autofill.php',
                            params: {
                                'depotId': vm.depotId,
                            },
                            deferRequestBy: 500,
                            minLength: 2,
                            minChars: 2,
                            onSelect: function (autofill) {
                                vm.setAutofill({
                                    autofill
                                });
                            }
                        });
                }
            },
            methods: {
                auto_layout_keyboard( str ) {
                    const replacer = {
                        "q":"й", "w":"ц", "e":"у", "r":"к", "t":"е", "y":"н", "u":"г",
                        "i":"ш", "o":"щ", "p":"з", "[":"х", "]":"ъ", "a":"ф", "s":"ы",
                        "d":"в", "f":"а", "g":"п", "h":"р", "j":"о", "k":"л", "l":"д",
                        ";":"ж", "'":"э", "z":"я", "x":"ч", "c":"с", "v":"м", "b":"и",
                        "n":"т", "m":"ь", ",":"б", ".":"ю", "/":"."
                    };

                    return str.replace(/[A-z/,.;\'\]\[]/g, function ( x ){
                        return x == x.toLowerCase() ? replacer[ x ] : replacer[ x.toLowerCase() ].toUpperCase();
                    });
                },
                setAutofill(autofill)
                {

                    this.$Bitrix.eventEmitter.emit('akatan:order_ticket:autofill', {
                        autofill
                    });
                },
            },
            unmounted() {

            },
        });
        this.#application.component("styler-departure", {
            props: ["options", "modelValue"],
            template: `<select placeholder="Откуда?">
                <option v-for="(station, station_index) in options" :key="station_index" :value="station_index">{{ station.Name }}</option>
            </select>`,
            mounted() {
                let vm = this;

                if (typeof vm.options['b53adeda-9c85-11ec-92d0-3cecef89b9c8'] !== 'undefined') {
                    vm.$emit("update:modelValue", 'b53adeda-9c85-11ec-92d0-3cecef89b9c8');
                }

                $(vm.$el)
                    .styler({
                        selectSearch: true
                    })
                    .val(this.modelValue)
                    .trigger("change")

                    .on("change", function() {
                        // console.info('change')
                        vm.$emit("update:modelValue", this.value);
                    })
                    .trigger('refresh');
            },
            watch: {
                modelValue(cur_value, prev_value) {
                    $(this.$el)
                        .val(cur_value)
                        .trigger("change")
                        .trigger('refresh');
                },
                options(options) {
                }
            },
            methods: {
                updateValue(event)
                {
                    const {cur_val} = event.getData();
                    this.component_value = cur_val
                },
            },
            unmounted() {
                $(this.$el)
                    .off()
                    .styler("destroy");

            },
            data() {
                return {
                }
            },
        });
        this.#application.component("from-datepicker", {
            data()
            {
                return {
                    date: {
                        day: '',
                        month: '',
                        year: '',
                        separator: '.'
                    }
                };
            },
            props: ["modelValue"],
            template: `<input type="text" placeholder="Когда" required="" :value="modelValue">`,
            mounted() {
                let vm = this;
                $(vm.$el)
                    .datepicker({
                        dateFormat: 'dd.mm.yyyy',
                        minDate: new Date(),
                        autoClose: true,
                        onSelect: function(dateText,inst) {
                            vm.$emit("update:modelValue", dateText);
                        }
                    })
                    .bind('input', function() {
                        let birthday = $(vm.$el).val();
                        let birthday_length;
                        birthday = birthday.replace(/[^0-9]/mgi, '');
                        birthday_length = birthday.length;

                        if (birthday_length > 8) {
                            birthday = birthday.slice(0,8);
                        }

                        birthday = vm.format_date(vm.validate_date(birthday), '.');

                        if (birthday.length === 10) {
                            let birthdateItemArr = birthday.split('.')
                            $(vm.$el).val(birthday)
                                .data('datepicker')
                                .selectDate(new Date(birthdateItemArr[2], parseInt(birthdateItemArr[1], '10') - 1, birthdateItemArr[0]));
                        }
                        vm.$emit("update:modelValue", birthday);
                    })
                    .trigger("change")
                    .trigger('refresh');
            },
            watch: {
                modelValue(current_date, prev_date) {
                },
            },
            methods: {
                validate_date(str_date)
                {
                    const regex = /(\d{0,2})(\d{0,2})(\d{0,4})/;
                    let day_group = str_date.match(regex);

                    // day
                    if (!!day_group[1] && day_group[1] !== '') {
                        const str_date_number_day = day_group[1].split('');
                        str_date_number_day[0] = str_date_number_day[0].replace(/[^0-3]/mgi, '');
                        if (day_group[1].length === 2) {
                            switch (parseInt(str_date_number_day[0])) {
                                case 0:
                                    str_date_number_day[1] = str_date_number_day[1].replace(/[^1-9]/mgi, '')
                                    break;
                                case 1:
                                case 2:
                                    str_date_number_day[1] = str_date_number_day[1].replace(/[^0-9]/mgi, '')
                                    break;
                                case 3:
                                    str_date_number_day[1] = str_date_number_day[1].replace(/[^0-1]/mgi, '')
                                    break;
                                default:
                                    str_date_number_day[1] = '';
                            }
                        }
                        day_group[1] = str_date_number_day.join('').trim();
                    }

                    // month
                    if (!!day_group[2] && day_group[2] !== '') {
                        let str_date_number_month = day_group[2].split('');
                        str_date_number_month[0] = str_date_number_month[0].replace(/[^0-1]/mgi, '');
                        if (day_group[2].length === 2) {
                            switch (parseInt(str_date_number_month[0])) {
                                case 0:
                                    str_date_number_month[1] = str_date_number_month[1].replace(/[^1-9]/mgi, '');
                                    break;
                                case 1:
                                    str_date_number_month[1] = str_date_number_month[1].replace(/[^0-2]/mgi, '')
                                    break;
                                default:
                                    str_date_number_month[1] = '';
                            }
                        }
                        day_group[2] = str_date_number_month.join('').trim();
                    }

                    // year
                    if (!!day_group[3] && day_group[3] !== '') {
                        let str_date_number_year = day_group[3].split('');

                        str_date_number_year[0] = str_date_number_year[0].replace(/[^12]/mgi, '');
                        if (day_group[3].length > 1 && str_date_number_year[1] !== '') {
                            switch (parseInt(str_date_number_year[0])) {
                                case 1:
                                    str_date_number_year[1] = str_date_number_year[1].replace(/[^9]/mgi, '');
                                    break;
                                case 2:
                                    str_date_number_year[1] = str_date_number_year[1].replace(/[^0]/mgi, '')
                                    break;
                                default:
                                    str_date_number_year[1] = '';
                            }
                        }

                        if (day_group[3].length > 2 && str_date_number_year[2] !== '') {
                            switch (parseInt(str_date_number_year[0])) {
                                case 1:
                                    str_date_number_year[2] = str_date_number_year[2].replace(/[^2-9]/mgi, '');
                                    break;
                                case 2:
                                    str_date_number_year[2] = str_date_number_year[2].replace(/[^0-2]/mgi, '')
                                    break;
                                default:
                                    str_date_number_year[2] = '';
                            }
                        }

                        if (day_group[3].length > 3 && str_date_number_year[3] !== '') {
                            switch (parseInt(str_date_number_year[0])) {
                                case 1:
                                    str_date_number_year[3] = str_date_number_year[3].replace(/[^0-9]/mgi, '');
                                    break;
                                case 2:
                                    str_date_number_year[3] = str_date_number_year[3].replace(/[^0-9]/mgi, '')
                                    break;
                                default:
                                    str_date_number_year[3] = '';
                            }
                        }

                        day_group[3] = str_date_number_year.join('').trim();

                    }
                    for (let birthday_length = day_group.length - 1; birthday_length > 0; birthday_length--) {
                        if (day_group[birthday_length] === '') {
                            day_group.splice(birthday_length,1);
                        }
                    }

                    day_group.splice(0,1);

                    return day_group;
                },
                format_date(date,separator)
                {
                    let i = 0;
                    let formated_date = '';
                    formated_date = date.join(separator).trim()

                    return formated_date;
                },
                updateValue(event)
                {
                    const {cur_val} = event.getData();
                    this.component_value = cur_val
                },
            },
            unmounted() {
                $(this.$el)
                    .off()
                    .datepicker("destroy");
            },
        });
        this.#application.component('select2', {
            props: ['options', 'modelValue'],
            template: `<select class="applySelect2">
                <template v-for="option in options">
                    <option v-bind:modelValue="option.id">{{option.value}}</option>
                </template>
            </select>`,
            mounted()
            {
                let vm = this
                $(this.$el)
                    .val(this.value)
                    // init select2
                    .select2({ data: this.options })
                    // emit event on change.
                    .on('change', function() {
                        vm.$emit("update:modelValue", this.value);
                    })
            },
            watch: {
                modelValue(curValue) {
                    // update value
                    $(this.$el).val(curValue)
                },
                options(options) {
                    // update options
                    $(this.$el).select2({ data: options })
                }
            },
            destroyed() {
                $(this.$el).off().select2('destroy')
            }
        });
        this.#application.mount(this.rootNode);
    }
}